import { Component, OnInit } from '@angular/core';
import { userDetails } from 'src/app/models/user.model';
import { MLSListingService } from 'src/services/mls-listings.service';
import { UserDetailService } from 'src/services/user-details.service';

@Component({
  selector: 'app-all-listings',
  templateUrl: './all-listings.component.html',
  styleUrls: ['./all-listings.component.css']
})
export class AllListingsComponent implements OnInit {

  userDetails : userDetails[];
  all_agents_id ='';
  listings: any;

  constructor(private UserDetailService:UserDetailService, private mlsService:MLSListingService) { }

  ngOnInit() {
    this.UserDetailService.getEveryone().subscribe(res => {
      // console.log((res as any).Users);
      this.userDetails = (res as any).Users;
      this.userDetails.sort((a,b) => a.full_name < b.full_name ? -1 : a.full_name > b.full_name ? 1: 0);
      for(var i=0; i<this.userDetails.length; i++) {
        if(this.userDetails[i].agentMLS_ID) {
          this.all_agents_id = this.all_agents_id + '&agent=' + this.userDetails[i].agentMLS_ID;
        }
        
      }
      //console.log(this.all_agents_id);
      this.mlsService.getStrideListings(this.all_agents_id).subscribe(res => {
        // console.log(res);
        this.listings = res as any;
      })

      

    });

  } 
  


  getPrice(x) {
    var price = parseInt(x);
    var final_price = '$' + this.numberWithCommas(price);
    return final_price;
  }


  numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getListingPageID(listing_id) {
    var link = '/listing/' + listing_id;
    return link;
  }

}
